import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { SelectProductsSupplier } from "../../../../../components/Selectors/SelectProductsSupplier";
import { ProductsOrder, setSupplierChangeDialog } from "../../../../../app/slices/productsOrdersSlice";
import { HiOutlineArrowsRightLeft, HiOutlineTruck } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const SupplierChangeForm = () => {
  const dispatch = useDispatch();
  const _SupplierChange = useSelector((state) => state.productsOrders.supplierChange);
  const _SearchBody = useSelector((state) => state.productsOrders.searchBody);
  const _ProductsSupplier = useSelector((state) => state.productSupplier.productsSupplier.data);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: _SupplierChange,
  });

  const onSubmit = (data) => {
    dispatch(ProductsOrder.supplierChange({
      order_id: _SupplierChange.order_id,
      supplier_id: data.supplier_id,
    }, _SearchBody))
  };

  const handleDialog = () => {
    dispatch(setSupplierChangeDialog({
      order_id: null,
      supplier_id: null,
    }));
  };

  return (
    <FormDialog
      open={_SupplierChange.dialog}
      onClose={handleDialog}
      icon={<HiOutlineArrowsRightLeft />}
      title={'تغيير المجهز'}
      subtitle="اختر المجهز الجديد ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineTruck />} title="المجهز">
        <Grid item xs={12}>
          <Controller
            name="supplier_id"
            control={control}
            render={({ field }) => (
              <SelectProductsSupplier
                required
                onChange={(e, newValue) => {
                  setValue("supplier_id", newValue.id);
                }}
                value={_ProductsSupplier?.filter((supplier) => supplier.name === field.value)[0] ||
                  _ProductsSupplier?.filter((supplier) => supplier.id === field.value)[0] || null}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default SupplierChangeForm;
